import { render, staticRenderFns } from "./scGPEA.vue?vue&type=template&id=6e0c2f1e&"
import script from "./scGPEA.vue?vue&type=script&lang=js&"
export * from "./scGPEA.vue?vue&type=script&lang=js&"
import style0 from "./scGPEA.vue?vue&type=style&index=0&id=6e0c2f1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports